<div class="grid">
  <div class="cell-toolbar">
    <cst-toolbar>
      <ctrl-btn-create
        i18n-title="@@InfoportalAPI_Contracts_Documents_FolderCreate"
        title="Create a new folder"
        (click)="documentsTree.onFolderCreate(contractNo)"
        [disabled]="!documentsTree.canFolderCreate(contractNo)"
      ></ctrl-btn-create>
    </cst-toolbar>
  </div>
  <div class="cell-list">
    <app-infoprtal-contract-documents-tree
      #documentsTree
      [contractNo]="contractNo"
    ></app-infoprtal-contract-documents-tree>
  </div>
</div>
